import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
    {
        path: '/',
        redirect: '/lottery'
    },
    {
        path: "/login",
        name: "Login",
        component: () => import("../views/Login.vue"),
        meta:{
            subTitle: 'Laidan'
        }
    },
    {
        path: "/lottery",
        name: "Lottery",
        component: () => import("../views/Lottery.vue"),
        meta:{
            subTitle: 'Laidan'
        }
    },
    {
        path: "/winning",
        name: "Winning",
        component: () => import("../views/Winning.vue"),
        meta:{
            subTitle: 'Laidan'
        }
    },
    {
        path: "/my-lottery",
        name: "MyLottery",
        component: () => import("../views/MyLottery.vue"),
        meta:{
            subTitle: 'Laidan'
        }
    },
    {
        path: "/laidan",
        name: "Laidan",
        component: () => import("../views/Laidan.vue"),
        meta:{
            subTitle: 'Laidan'
        }
    },
    {
        path: "/member",
        name: "Member",
        component: () => import("../views/Member.vue"),
        meta:{
            subTitle: 'Laidan'
        }
    },
    {
        path: "/shared-cards/:id",
        name: "SharedCards",
        component: () => import("../views/SharedCards.vue"),
        meta:{
            subTitle: 'Laidan'
        }
    },
    {
        path: "/shared-book/:id",
        name: "SharedBook",
        component: () => import("../views/SharedBook.vue"),
        meta:{
            subTitle: 'Laidan'
        }
    },
    {
        path: "/joinku",
        name: "Joinku",
        component: () => import("../views/Joinku.vue"),
        meta:{
            subTitle: 'Joinku'
        }
    },
    {
        path: "/invite",
        name: "Invite",
        component: () => import("../views/Invite.vue"),
        meta:{
            subTitle: 'Joinku'
        }
    },
    {
        path: "/invite",
        name: "Invite",
        component: () => import("../views/Invite.vue"),
        meta:{
            subTitle: 'Joinku'
        }
    },
    {
        path: "/menu-preview/:id",
        name: "MenuPreview",
        component: () => import("../views/MenuPreview.vue"),
        meta:{
            subTitle: 'Pointsme'
        }
    },
    {
        path: "/menu-pc/:id",
        name: "MenuPc",
        component: () => import("../views/MenuPc.vue"),
        meta:{
            subTitle: 'Pointsme'
        }
    },
    {
        path: "/menu-mobile/:id",
        name: "MenuMobile",
        component: () => import("../views/MenuMobile.vue"),
        meta:{
            subTitle: 'Pointsme'
        }
    },
    {
        path: "/dishes-detail/:id",
        name: "DishesDetail",
        component: () => import("../views/DishesDetail.vue"),
        meta:{
            subTitle: 'Pointsme'
        }
    },
    {
        path: "/set-meal/:id",
        name: "SetMeal",
        component: () => import("../views/SetMeal.vue"),
        meta: {
            keepAlive: true
        }
    },
    {
        path: "/raw-material/:id",
        name: "RawMaterial",
        component: () => import("../views/RawMaterial.vue"),
    },
    {
        path: "/woka-activity",
        name: "WokaActivity",
        component: () => import("../views/WokaActivity.vue"),
        meta:{
            subTitle: 'Pointsme'
        }
    },
    {
        path: "/404",
        name: "notFound",
        component: () => import("../views/NotFound.vue")
    },
    {
        path: "*",
        redirect: "/404"
    }
];

const router = new VueRouter({
    routes
});

export default router;
